import {ActiveJobsTypes} from '../ActionTypes/ActiveJobsTypes';

let initialSate = {
  activeJobs: [],
  activeJobsPagination: null,
  completedJobs: [],
  completedJobsPagination: null,
};

const ActiveJobsReducer = (state = initialSate, action) => {
  switch (action.type) {
    case ActiveJobsTypes.GET_ACTIVE_JOBS_LIST:
      let activeJobs_Copy = [];
      activeJobs_Copy = [...state.activeJobs, ...action.payload.data];
      state = {
        ...state,
        activeJobsPagination: action.payload,
        activeJobs: activeJobs_Copy,
      };
      break;

    case ActiveJobsTypes.CLEAR_ACTIVE_JOBS_LIST:
      state = {
        activeJobs: [],
        activeJobsPagination: null,
      };
      break;
    case ActiveJobsTypes.GET_COMPLETED_JOBS_LIST:
      let completedJobs_Copy = [];
      completedJobs_Copy = [...state.completedJobs, ...action.payload.data];
      state = {
        ...state,
        completedJobsPagination: action.payload,
        completedJobs: completedJobs_Copy,
      };
      break;

    case ActiveJobsTypes.CLEAR_COMPLETED_JOBS_LIST:
      state = {
        completedJobs: [],
        completedJobsPagination: null,
      };
      break;
  }
  return state;
};

export default ActiveJobsReducer;
